import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Toolbar } from '@material-ui/core';

const MainNavbar = (props) => (
  <AppBar
    elevation={0}
    {...props}
  >
    <Toolbar sx={{ height: 64 }}>
      <RouterLink to="/" style={{ lineHeight: 0 }}>
        <img alt="Logo Parcels App" src='//dvow0vltefbxy.cloudfront.net/assets/logo-c151ed396f2a7b7e0b34ba1490740dd9547013b7645c74af377b1dd60cf6aa3b.png' width="40px" height="40px" />
      </RouterLink>
    </Toolbar>
  </AppBar>
);

export default MainNavbar;
